
<ng-container *ngIf="(state?.orgs$ | async) as orgs">
  <span *ngIf="orgs.length > 1" class="p-float-label mt-4">
    <p-dropdown
      [options]="orgsOptions"
      [(ngModel)]="selectedOrgId"
      (onChange)="onSelect($event)"
      [filter]="orgs.length > 5"
      optionValue="id"
      [filterFields]="['legalName', 'id', 'uuid']"
      styleClass="w-full"
      id="selectedOrg">
      <ng-template let-item pTemplate="item">
        <ng-container [ngTemplateOutlet]="orgName" [ngTemplateOutletContext]="{item:item}"></ng-container>
      </ng-template>
      <ng-template let-item pTemplate="selectedItem">
        <ng-container [ngTemplateOutlet]="orgName" [ngTemplateOutletContext]="{item:item}"></ng-container>
      </ng-template>
    </p-dropdown>
    <label for="selectedOrg">{{ 'admin.shared.selectable-orgs-dropdown.selected-org' | translate }}</label>
  </span>
</ng-container>


<ng-template let-item="item" #orgName>
  <div data-id="{{ item?.id }}">
    {{ (item?.legalName || 'admin.shared.selectable-orgs-dropdown.no-name-org') | translate }}
  </div>
</ng-template>
